// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.ArrowLeftSmall = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.ArrowLeftSmall = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var ArrowLeftSmall = _exports.ArrowLeftSmall = function ArrowLeftSmall(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M17.2925 9.99819C17.2925 10.3432 17.0125 10.6232 16.6675 10.6232H4.8434L7.11004 12.8898C7.35421 13.134 7.35421 13.5299 7.11004 13.774C6.98837 13.8957 6.82835 13.9573 6.66835 13.9573C6.50835 13.9573 6.34833 13.8965 6.22666 13.774L2.89333 10.4407C2.83583 10.3832 2.7901 10.3141 2.75844 10.2374C2.6951 10.0849 2.6951 9.91245 2.75844 9.75995C2.7901 9.68328 2.83583 9.614 2.89333 9.5565L6.22666 6.22316C6.47083 5.979 6.86669 5.979 7.11086 6.22316C7.35502 6.46733 7.35502 6.86319 7.11086 7.10736L4.84421 9.374H16.6675C17.0125 9.37317 17.2925 9.65319 17.2925 9.99819Z",
      fill: "currentColor"
    }));
  };
});
